var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lobster);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto);", ""]);

// module
exports.push([module.id, "*{font-family:Roboto,sans-serif;margin:0;padding:0}h1{font-family:Lobster;font-weight:400;font-size:40px;color:#8ab42e}#div-h1{padding:0 20px;background:#e8e1ce;display:inline-block;transform:rotate(-3deg);transition:1s}#div-h1:hover{box-shadow:0 0 20px #8ab42e;transform:rotate(0deg)}body{background-image:url(" + escape(require("../print_texture.png")) + ")}main{padding-top:20px}.img_container{overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/assets/css/main.css
// module id = 330
// module chunks = 0